import type { SharingButton } from './sharing-modal.types';

export const sharingButtons: SharingButton[] = [
  // {
  //   text: 'Copy Link',
  //   id: 'clipboard',
  // },
  // {
  //   text: 'Whatsapp',
  //   id: 'whatsapp',
  // },
  // {
  //   text: 'Messenger',
  //   id: 'messenger',
  // },
  {
    text: 'Facebook',
    id: 'facebook',
  },
  // {
  //   text: 'Twitter',
  //   id: 'twitter',
  // },
];
